import IconBSC from 'assets/icons/BSC.svg';
import IconPolygon from 'assets/icons/Polygon.svg';
import IconDogeChain from 'assets/icons/DogeChain.svg';


export const _CHAIN_DATA = {
    bsc: {
      mainnet: {
        id: 56,
        rpc: [
          'https://bsc-dataseed2.binance.org:443',
          'https://bsc.publicnode.com', // can be unstable
          'https://bsc-dataseed1.binance.org:443',
        ],
        explorer: 'https://bscscan.com/',
      },
      testnet: {
        id: 97,
        rpc: ['https://data-seed-prebsc-1-s1.binance.org:8545', 'https://data-seed-prebsc-1-s2.binance.org:8545'],
        explorer: 'https://testnet.bscscan.com/',
      },
      tickerSymbol: 'BNB',
      logo: IconBSC,
      name: 'bsc',
      nameFancy: 'Binance Smart Chain'
    },
  
    polygon: {
      mainnet: {
        id: 137,
        rpc: ['https://polygon-rpc.com'],
        explorer: 'https://polygonscan.com/'
      },
      testnet: {
        id: 80001,
        rpc: ['https://matic-mumbai.chainstacklabs.com'],
        explorer: 'https://mumbai.polygonscan.com/',
      },
      tickerSymbol: 'MATIC',
      logo: IconPolygon,
      name: 'polygon',
      nameFancy: 'Polygon'
    },

    dogechain: {
      mainnet: {
        id: 2000,
        rpc: [
            'https://rpc.ankr.com/dogechain', 'https://rpc.dogechain.dog', 'https://rpc-us.dogechain.dog',
            'https://rpc01.dogechain.dog'
        ],
        explorer: 'https://explorer.dogechain.dog/',
      },
      testnet: {
        id: 568,
        rpc: ['https://rpc-testnet.dogechain.dog'],
        explorer: 'https://explorer-testnet.dogechain.dog/',
      },
      tickerSymbol: 'wDOGE',
      logo: IconDogeChain,
      name: 'dogechain',
      nameFancy: 'DogeChain'
    },
  }
